'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Textarea = require('../../Textarea/src/Textarea.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const InputView = React__namespace.forwardRef((props, ref) => {
    const { children, ...restProps } = props;
    if (children) {
        const child = React__namespace.Children.only(children);
        const inputProps = {
            ...restProps,
            ...child.props,
            // eslint-disable-next-line react-hooks/rules-of-hooks
            ref: reactUtils.useMergedRef(ref, child.ref),
        };
        return React__namespace.cloneElement(child, inputProps);
    }
    return React__namespace.createElement(Textarea.Textarea, { ref: ref, ...restProps });
});

exports.InputView = InputView;
//# sourceMappingURL=InputView.js.map
